import _ from 'lodash'
import { tmrDialogController } from 'tmr/controllers/dialog/dialog'
import templateUrl from './itemsByUpcDialog.html'
import './itemsByUpcDialog.scss'

/**
 * Configures dialog Items by Upc (preset `tmrItemsByUpc`).
 *
 * @type {ngConfig}
 */
function tmrItemsByUpcDialogConfig($mdDialogProvider) {
  'ngInject'
  $mdDialogProvider.addPreset('tmrItemsByUpc', {
    options: /*@ngInject*/ () => ({
      templateUrl,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: 'tmrItemsByUpcDialogConfigController',
      controllerAs: '$ctrl',
      bindToController: true,
      locals: {
        upc: '?',
        unexpected: true,
        missing: false,
        epcs: [],
        expectedEpcs: [],
        statusByEpc: null,
      },
      resolve: {
        productImageEnabled: /*@ngInject*/ TmrAppConfiguration =>
          TmrAppConfiguration.get('product.image.enabled'),
      },
    }),
  })
}

export { tmrItemsByUpcDialogConfig as config }

/**
 * Controller of Dialog {@link tmrItemsByUpcDialogConfig tmrItemsByUpc}.
 *
 * @type {ngController}
 */
export class tmrItemsByUpcDialogConfigController extends tmrDialogController {
  constructor($mdDialog, $transitions, Item, Product) {
    'ngInject'
    super($mdDialog, $transitions)
    Object.assign(this, { Item, Product })
  }

  $onInit() {
    super.$onInit()
    this.itemsByEpc = {}

    // Store before integrating missing epcs from parcel.
    this.readQuantity = this.epcs.length

    // The parcel is complete (parcel detail) and some tags are missing.
    if (this.missing) {
      this.detected = _.intersection(this.epcs, this.expectedEpcs)
      this.epcs = _.union(this.expectedEpcs, this.epcs)
    }

    if (this.epcs.length) {
      this.Item.query({ epc: this.epcs }).$promise.then(items =>
        items.forEach(item => (this.itemsByEpc[item.epc] = item))
      )
    }

    this.product = this.upc ? this.Product.getByUpc(this.upc) : {}

    // Remove undefined statuses.
    for (let epc in this.statusByEpc) {
      if (this.statusByEpc[epc] === undefined) delete this.statusByEpc[epc]
    }
    // Show status column only if we have at least one status.
    this.showStatusColumn = Object.values(this.statusByEpc).length > 0
  }

  getColor() {
    return this.unexpected
      ? 'default-warn'
      : this.missing
      ? 'default-yellow'
      : 'default-temeraGreen'
  }
}
